
export const SCALE = [
  {pitch: 1, short: 'A0', english: 'A0', german: ',,A', frequency: 27.5000},
  {pitch: 2, short: 'Bb0', english: 'A#0/Bb0', german: ',,Ais/,,B', frequency: 29.1353},
  {pitch: 3, short: 'B0', english: 'B0', german: ',,H', frequency: 30.8677},
  {pitch: 4, short: 'C1', english: 'C1', german: ',C', frequency: 32.7032},
  {pitch: 5, short: 'C#1', english: 'C#1/Db1', german: ',Cis/,Des', frequency: 34.6479},
  {pitch: 6, short: 'D1', english: 'D1', german: ',D', frequency: 36.7081},
  {pitch: 7, short: 'Eb1', english: 'D#1/Eb1', german: ',Dis/,Es', frequency: 38.8909},
  {pitch: 8, short: 'E1', english: 'E1', german: ',E', frequency: 41.2035},
  {pitch: 9, short: 'F1', english: 'F1', german: ',F', frequency: 43.6536},
  {pitch: 10, short: 'F#1', english: 'F#1/Gb1', german: ',Fis/,Ges', frequency: 46.2493},
  {pitch: 11, short: 'G1', english: 'G1', german: ',G', frequency: 48.9995},
  {pitch: 12, short: 'G#1', english: 'G#1/Ab1', german: ',Gis/,As', frequency: 51.9130},
  {pitch: 13, short: 'A1', english: 'A1', german: ',A', frequency: 55.0000},
  {pitch: 14, short: 'Bb1', english: 'A#1/Bb1', german: ',Ais/,B', frequency: 58.2705},
  {pitch: 15, short: 'B1', english: 'B1', german: ',H', frequency: 61.7354},
  {pitch: 16, short: 'C2', english: 'C2', german: 'C', frequency: 65.4064},
  {pitch: 17, short: 'C#2', english: 'C#2/Db2', german: 'Cis/Des', frequency: 69.2957},
  {pitch: 18, short: 'D2', english: 'D2', german: 'D', frequency: 73.4162},
  {pitch: 19, short: 'Eb2', english: 'D#2/Eb2', german: 'Dis/Es', frequency: 77.7817},
  {pitch: 20, short: 'E2', english: 'E2', german: 'E', frequency: 82.4069},
  {pitch: 21, short: 'F2', english: 'F2', german: 'F', frequency: 87.3071},
  {pitch: 22, short: 'F#2', english: 'F#2/Gb2', german: 'Fis/Ges', frequency: 92.4986},
  {pitch: 23, short: 'G2', english: 'G2', german: 'G', frequency: 97.9989},
  {pitch: 24, short: 'G#2', english: '#2/Ab2', german: 'Gis/As', frequency: 103.826},
  {pitch: 25, short: 'A2', english: 'A2', german: 'A', frequency: 110.000},
  {pitch: 26, short: 'Bb2', english: 'A#2/Bb2', german: 'Ais/B', frequency: 116.541},
  {pitch: 27, short: 'B2', english: 'B2', german: 'H', frequency: 123.471},
  {pitch: 28, short: 'C3', english: 'C3', german: 'c', frequency: 130.813},
  {pitch: 29, short: 'C#3', english: 'C#3/Db3', german: 'cis/des', frequency: 138.591},
  {pitch: 30, short: 'D3', english: 'D3', german: 'd', frequency: 146.832},
  {pitch: 31, short: 'Eb3', english: 'D#3/Eb3', german: 'dis/es', frequency: 155.563},
  {pitch: 32, short: 'E3', english: 'E3', german: 'e', frequency: 164.814},
  {pitch: 33, short: 'F3', english: 'F3', german: 'f', frequency: 174.614},
  {pitch: 34, short: 'F#3', english: 'F#3/Gb3', german: 'fis/ges', frequency: 184.997},
  {pitch: 35, short: 'G3', english: 'G3', german: 'g', frequency: 195.998},
  {pitch: 36, short: 'G#3', english: 'G#3/Ab3', german: 'gis/as', frequency: 207.652},
  {pitch: 37, short: 'A3', english: 'A3', german: 'a', frequency: 220.000},
  {pitch: 38, short: 'Bb3', english: 'A#3/Bb3', german: 'ais/b', frequency: 233.082},
  {pitch: 39, short: 'B3', english: 'B3', german: 'h', frequency: 246.942},
  {pitch: 40, short: 'C4', english: 'C4', german: 'c’', frequency: 261.626},
  {pitch: 41, short: 'C#4', english: 'C#4/Db4', german: 'cis’/des’', frequency: 277.183},
  {pitch: 42, short: 'D4', english: 'D4', german: 'd’', frequency: 293.665},
  {pitch: 43, short: 'Eb4', english: 'D#4/Eb4', german: 'dis’/es’', frequency: 311.127},
  {pitch: 44, short: 'E4', english: 'E4', german: 'e’', frequency: 329.628},
  {pitch: 45, short: 'F4', english: 'F4', german: 'f’', frequency: 349.228},
  {pitch: 46, short: 'F#4', english: 'F#4/Gb4', german: 'fis’/ges’', frequency: 369.994},
  {pitch: 47, short: 'G4', english: 'G4', german: 'g’', frequency: 391.995},
  {pitch: 48, short: 'G#4', english: 'G#4/Ab4', german: 'gis’/as’', frequency: 415.305},
  {pitch: 49, short: 'A4', english: 'A4', german: 'a’', frequency: 440.000},
  {pitch: 50, short: 'Bb4', english: 'A#4/Bb4', german: 'ais’/b’', frequency: 466.164},
  {pitch: 51, short: 'B4', english: 'B4', german: 'h’', frequency: 493.883},
  {pitch: 52, short: 'C5', english: 'C5', german: 'c’’', frequency: 523.251},
  {pitch: 53, short: 'C#5', english: 'C#5/Db5', german: 'cis’’/des’’', frequency: 554.365},
  {pitch: 54, short: 'D5', english: 'D5', german: 'd’’', frequency: 587.330},
  {pitch: 55, short: 'Eb5', english: 'D#5/Eb5', german: 'dis’’/es’’', frequency: 622.254},
  {pitch: 56, short: 'E5', english: 'E5', german: 'e’’', frequency: 659.255},
  {pitch: 57, short: 'F5', english: 'F5', german: 'f’’', frequency: 698.456},
  {pitch: 58, short: 'F#5', english: 'F#5/Gb5', german: 'fis’’/ges’’', frequency: 739.989},
  {pitch: 59, short: 'G5', english: 'G5', german: 'g’’', frequency: 783.991},
  {pitch: 60, short: 'G#5', english: 'G#5/Ab5', german: 'gis’’/as’’', frequency: 830.609},
  {pitch: 61, short: 'A5', english: 'A5', german: 'a’’', frequency: 880.000},
  {pitch: 62, short: 'Bb5', english: 'A#5/Bb5', german: 'ais’’/b’’', frequency: 932.328},
  {pitch: 63, short: 'B5', english: 'B5', german: 'h’’', frequency: 987.767},
  {pitch: 64, short: 'C6', english: 'C6', german: 'c’’’', frequency: 1046.50},
  {pitch: 65, short: 'C#6', english: 'C#6/Db6', german: 'cis’’’/des’’’', frequency: 1108.73},
  {pitch: 66, short: 'D6', english: 'D6', german: 'd’’’', frequency: 1174.66},
  {pitch: 67, short: 'Eb6', english: 'D#6/Eb6', german: 'dis’’’/es’’’', frequency: 1244.51},
  {pitch: 68, short: 'E6', english: 'E6', german: 'e’’’', frequency: 1318.51},
  {pitch: 69, short: 'F6', english: 'F6', german: 'f’’’', frequency: 1396.91},
  {pitch: 70, short: 'F#6', english: 'F#6/Gb6', german: 'fis’’’/ges’’’', frequency: 1479.98},
  {pitch: 71, short: 'G6', english: 'G6', german: 'g’’’', frequency: 1567.98},
  {pitch: 72, short: 'G#6', english: 'G#6/Ab6', german: 'gis’’’/as’’’', frequency: 1661.22},
  {pitch: 73, short: 'A6', english: 'A6', german: 'a’’’', frequency: 1760.00},
  {pitch: 74, short: 'Bb6', english: 'A#6/Bb6', german: 'ais’’’/b’’’', frequency: 1864.66},
  {pitch: 75, short: 'B6', english: 'B6', german: 'h’’’', frequency: 1975.53},
  {pitch: 76, short: 'C7', english: 'C7', german: 'c’’’’', frequency: 2093.00},
  {pitch: 77, short: 'C#7', english: 'C#7/Db7', german: 'cis’’’’/des’’’’', frequency: 2217.46},
  {pitch: 78, short: 'D7', english: 'D7', german: 'd’’’’', frequency: 2349.32},
  {pitch: 79, short: 'Eb7', english: 'D#7/Eb7', german: 'dis’’’’/es’’’’', frequency: 2489.02},
  {pitch: 80, short: 'E7', english: 'E7', german: 'e’’’’', frequency: 2637.02},
  {pitch: 81, short: 'F7', english: 'F7', german: 'f’’’’', frequency: 2793.83},
  {pitch: 82, short: 'F#7', english: 'F#7/Gb7', german: 'fis’’’’/ges’’’’', frequency: 2959.96},
  {pitch: 83, short: 'G7', english: 'G7', german: 'g’’’’', frequency: 3135.96},
  {pitch: 84, short: 'Ab7', english: 'G#7/Ab7', german: 'gis’’’’/as’’’’', frequency: 3322.44},
  {pitch: 85, short: 'A7', english: 'A7', german: 'a’’’’', frequency: 3520.00},
  {pitch: 86, short: 'Bb7', english: 'A#7/Bb7', german: 'ais’’’’/b’’’’', frequency: 3729.31},
  {pitch: 87, short: 'B7', english: 'B7', german: 'h’’’’', frequency: 3951.07},
  {pitch: 88, short: 'C8', english: 'C8', german: 'c’’’’’', frequency: 4186.01}
]

/**
 * Returns the Note corresponding to the pitch.
 * @param {number} pitch - Pitch of a note
 * @returns {Note} The note
 */
export let findNote = pitch => SCALE.find(note => note.pitch === pitch)

export let getShortName = pitch => findNote(pitch).short
export let getEnglishName = pitch => findNote(pitch).english
export let getGermanName = pitch => findNote(pitch).german
export let getFrequency = pitch => findNote(pitch).frequency




// WEBPACK FOOTER //
// ./src/solfege.js